import React, { Component } from 'react';
import { DataAgence } from '../../data/DataAgence';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxAgence extends Component {

    static defaultProps = {
        filtreSurMonPerimetre: false,
        idRegion: undefined,
        idRegionRequired: true, // Par défaut la CB ne se chargera que si l'idRegion est renseigné
        label: "Agence",
        placeholder: "Agence",
    };

    render = () => {

        const { filtreSurMonPerimetre, idRegion, idRegionRequired } = this.props;

        let fetchMethod;
        if (!idRegionRequired || !!idRegion)
            fetchMethod = () => DataAgence._chargementAgencePerimetreEiffage(idRegion, filtreSurMonPerimetre);

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item.idAgence}
            itemText={item => item.agence}
            stamp={[filtreSurMonPerimetre, idRegion, idRegionRequired]}
        />;

    };

};